import type { Marker } from './types'

/**
 * localStorage map of journeys prepared on this device. Read on EVERY boot by
 * bootstrap.ts (before any request) to decide whether the add-on chunk must be
 * loaded first; mirrored into IndexedDB `meta/sw-map` for the service worker.
 */
export const MARKER_KEY = 'epilot-offline-journeys'

export const readMarker = (storage: Pick<Storage, 'getItem'>): Marker => {
  try {
    const parsed: unknown = JSON.parse(storage.getItem(MARKER_KEY) ?? '{}')

    return parsed && typeof parsed === 'object' ? (parsed as Marker) : {}
  } catch {
    return {}
  }
}

export const writeMarker = (
  storage: Pick<Storage, 'setItem'>,
  marker: Marker
): void => {
  try {
    storage.setItem(MARKER_KEY, JSON.stringify(marker))
  } catch {
    // private mode / quota: the add-on still works for this session
  }
}
